import React, { useState, useEffect, useContext } from "react";
import { Card, Image } from "react-bootstrap";
import { Navbar, Col, Row, Form, FormGroup, Label, Input, CardBody } from "reactstrap";
import { Button } from "react-bootstrap";
import logo from "../assets/img/illustrations/new-sikka-logo.png";
import { Document, Page, pdfjs } from "react-pdf";
import SignaturePad from "react-signature-pad-wrapper";
import APICall from "../services/apiCall";
import AppContext from "../context/Context";
import SamplePdf from "../assets/pdf/sample-pdf.pdf";
import SikkaInput from "../components/common/SikkaInput";
import { useForm } from "react-hook-form";
import SikkaError from "../components/common/SikkaError";
import classNames from "classnames";
import NDASignatureRoger from "../assets/img/nda/roger_sign.png";
import AuthService from "../services/authenticationService";
import { useHistory } from "react-router-dom";
import "./pdfStyles.css";
import "react-pdf/dist/umd/Page/AnnotationLayer";
import { toast } from "react-toastify";
import Dropzone from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loader from "../components/common/Loader";
import LoadingButton from "../components/common/LoadingButton";

const SignNDA = () => {
  const [numPages, setNumPages] = useState(null);
  // const [pageNumber, setPageNumber] = useState(1);
  const [trimmedDataURL, setTrimmedDataURL] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [uploadNDABoolean, setUploadNDABoolean] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [uploadedNDAFile, setUploadedNDAFile] = useState("");
  const [uploadedNDAFileName, setUploadedNDAFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [partnerInfo, setPartnerInfo] = useState({});
  const [signatureError, setSignatureError] = useState("");
  const [uploadNDAFileError, setUploadNDAFileError] = useState("");

  let history = useHistory();

  const getTempData = JSON.parse(localStorage.getItem("tempData"));

  let sigPad = {};

  const clear = () => {
    sigPad.clear();
  };

  const trim = () => {
    setTrimmedDataURL(sigPad.getTrimmedCanvas().toDataURL("image/png"));
  };

  useEffect(() => {
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${
      pdfjs.version
    }/pdf.worker.js`;
  }, []);

  const { loginUserDetails, setLoginUserDetails, accessToken } = useContext(
    AppContext
  );

  const { register, handleSubmit, errors } = useForm();

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const handleSubmitNDASubmit = (values) => {
    if (!sigPad.isEmpty()) {
      let body = {
        dev_id: loginUserDetails.dev_id, //parent dev id
        company_name: values.otherParty, //other party company name
        signed_by: values.by, //other party signed_by
        name: values.name, //other party name
        title: values.title, //oter party title
        signature: sigPad.toDataURL("image/jpeg").split(",")[1], // You can pass base 64 string in this parameter if not able to convert byte.
        signature_byte: "", //you can pass byte in this paramater if you can convert signature in byte else blank. either pass signature or signature_byte
        date: values.date, //other party date
        address:
          loginUserDetails.dev_add1 +
          " " +
          loginUserDetails.dev_city +
          ", " +
          loginUserDetails.dev_state +
          " " +
          loginUserDetails.dev_zip, //partner address == dev_add1 + " " + dev_city + ", " + dev_state + " " + dev_zip // you can get this details from nda_authentication API
        partner_name: loginUserDetails.partner_name, // you can get this details from nda_authentication API
        dev_name: loginUserDetails.dev_name, // you can get this details from nda_authentication API
        user_name: loginUserDetails.user_name,
        add_updated_by: loginUserDetails.is_partner === "0" ? "true" : "false",
        purpose:values.purpose // you can get this details from nda_authentication API
      };
      setSignatureError("");
      setLoading(true);
      APICall.servertrip("POST", "sign_nda", loginUserDetails, undefined, body) // data in {}
        .then((res) => {
          setLoading(false);
          toast.success("NDA signed successfully");
          loginUserDetails.nda_status = "signed";
          setLoginUserDetails(Object.assign({}, loginUserDetails));
          window.location.assign(`${process.env.PUBLIC_URL}/user/applications`);
        })
        .catch((error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          // toast.error(resMessage);
          toast.warning(
            error?.response?.data.long_message +
              " " +
              error?.response?.data.more_information
          );
          setLoading(false);
        });
    } else {
      setSignatureError("User Signature must required.");
      toast.error("User Signature must required");
    }
  };

  const handleUploadingNDAFile = () => {
    if (uploadedNDAFile) {
      setLoading(true);
      let body = {
        dev_id: loginUserDetails.dev_id, //parent dev id
        partner_name: loginUserDetails.partner_name, // you can get this details from nda_authentication API
        dev_name: loginUserDetails.dev_name, // you can get this details from nda_authentication API
        user_name: loginUserDetails.user_name, // you can get this details from nda_authentication API
        pdf_file_name: uploadedNDAFileName,
        pdf_file_byte: uploadedNDAFile,
      };

      setUploadNDAFileError("")
      APICall.servertrip(
        "POST",
        "upload_nda",
        loginUserDetails,
        undefined,
        body
      ) // data in {}
        .then((res) => {
         toast.success("NDA uploaded successfully.");
          setLoading(false);
          AuthService.logout();
          history.push("/v4/portal/authentication/login");
        })
        .catch((error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          // toast.error(resMessage);
          toast.warning(
            error?.response?.data.long_message +
              " " +
              error?.response?.data.more_information
          );
          setLoading(false);

        });
    } else {
      setUploadNDAFileError("Please,Upload the NDA file.")
      toast.error("Please upload the NDA file");
    }
  };

  const [isFileError, setIsFileError] = useState(false);

  const handleDrop = (files) => {
    const reader = new FileReader();
    let file = files[0];
    setIsFileError(false);
    if (file.size < 2100000) {
      reader.onload = (event) => {
        setUploadedNDAFile(event.target.result.split(",")[1]);
      };
      reader.readAsDataURL(file);
      setFileNames(files.map((file) => file.name));
      setUploadedNDAFileName(file.name);
      setIsFileError(false);
    } else {
      setIsFileError(true);
      setFileNames([]);
      setUploadedNDAFileName("");
      // toast.error("please file size should not more than 2MB");
    }
  };
const address = loginUserDetails.dev_add1 +" "+loginUserDetails.dev_city+", "+ loginUserDetails.dev_state +" "+ loginUserDetails.dev_zip
const company_name = loginUserDetails.partner_name
  return (
    <>
      {uploadNDABoolean ? (
        <>
          <Navbar
            light
            className="navbar-glass fs--1 font-weight-semi-bold row navbar-top sticky-kit m-0 p-3"
          >
            <img
              className="ml-3"
              src={logo}
              alt="Logo"
              width="100%"
              height="auto"
              style={{ maxWidth: "150px" }}
            />
          </Navbar>
          <div className="p-4">
            <Button
              variant="link"
              className="ml-3 mb-2 icon-item icon-item-sm icon-item-hover shadow-none p-0 me-lg-2"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setUploadNDABoolean(false);
              }}
            >
              <FontAwesomeIcon className="mr-2" icon="arrow-left" /> Back
            </Button>
            <Dropzone
              className="cursor-pointer"
              onDrop={handleDrop}
              multiple={false}
              accept="application/pdf"
            >
              {({ getRootProps, getInputProps }) => (
                <div
                  {...getRootProps({ className: "dropzone" })}
                  style={{ cursor: "pointer" }}
                >
                  <input {...getInputProps()} />
                  <p>Select or Drag'n'drop NDA file here</p>
                </div>
              )}
            </Dropzone>
            {isFileError && (
              <>
                <p className="text-danger text-center">
                  Please, the file size should not exceed a 2 MB limit.
                </p>
              </>
            )}

            {uploadNDAFileError ? (
              <>
                {" "}
                <p className="text-danger text-center">
                 {uploadNDAFileError}
                </p>
              </>
            ) : (
              <></>
            )}
            <div>
              <strong>Uploaded File:</strong>
              <ul>
                {fileNames.map((fileName) => (
                  <li key={fileName}>{fileName}</li>
                ))}
              </ul>
            </div>
            <Col className="d-flex justify-content-center mt-2">
              <Button
                size="sm"
                color="danger"
                onClick={handleUploadingNDAFile}
                style={{ width: "330px" }}
              >
                Upload File
              </Button>
            </Col>
          </div>
        </>
      ) : (
        <div>
          <Navbar
            light
            className="navbar-glass fs--1 font-weight-semi-bold row navbar-top sticky-kit m-0 p-3"
          >
            <img
              className="ml-3"
              src={logo}
              alt="Logo"
              width="100%"
              height="auto"
              style={{ maxWidth: "150px" }}
            />
          </Navbar>
          <Card className="bg-transparent-50 mx-2 mx-md-3 mx-lg-4 mb-3 mt-6 mt-sm-0 mt-md-0 mt-lg-0">
            {}
            <Card.Header style={{ display: "flex", justifyContent: "center" }}>
              <div className="position-relative z-index-2">
              <Card>
                <CardBody className="p-3 scrollable-div fs--1 ">
                This Agreement is made and entered into, as of <u>{new Date().getFullYear()}-{new Date().toLocaleString("default", { month: "short" })}-{new Date().getDate()}</u>, by and between Sikka Software Corporation having a principal place of business
                 at 2870 Zanker Rd Suite 120, San Jose, CA 95134 and {company_name} having a principal place of business at {address}.
            <br/><br/>
            1. Definition of Confidential Information."Confidential Information" means (a) any technical and non-technical information related to a party's business and current, future and proposed products and services of each of the parties, including for example and without limitation, each party's respective information concerning research, development, design details and specifications, financial information, procurement requirements, engineering and manufacturing information, customer lists, business forecasts, sales information and marketing plans and (b) any information a party has received from a third party that may be disclosed and which that party has an obligation to the third party to treat as confidential or proprietary, except that information disclosed by Discloser will be considered Confidential Information of Discloser by Recipient, only if the information (i) is provided as information fixed in tangible form or in writing (e.g., paper, disk or electronic mail), is conspicuously designated as "Confidential" (or with some other similar legend) or (ii) if provided orally or visually, is identified as confidential at the time of disclosure and confirmed in writing within 30 days of disclosure. For purposes of this Agreement, "Discloser" means the party disclosing the Confidential Information and "Recipient" means the party to whom Confidential Information is disclosed.
            <br/><br/>
            2. Nondisclosure and Nonuse Obligations.Recipient will not use any Confidential Information except to the extent necessary for the purpose described below the signatures to this Agreement (the "Purpose") and Recipient will not disseminate or in any way disclose any Confidential Information to any third party, except as such disclosure is expressly permitted in this Agreement. Furthermore, neither party may disclose the existence of any negotiations, discussions or consultations in progress between the parties to any third party or make any public announcement of such negotiations, discussions or consultations without the prior written approval of the other party. Recipient shall treat all of Discloser's Confidential Information with the same degree of care as Recipient accords to Recipient's own Confidential Information, but not less than reasonable care. Recipient shall disclose Discloser's Confidential Information only to those of Recipient's employees, consultants and contractors who need to know the information to assist Recipient with respect to the Purpose. Recipient certifies that each of its employees, consultants and contractors will have agreed, either as a condition of employment or in order to obtain Discloser's Confidential Information, to be bound by terms and conditions substantially similar to those terms and conditions applicable to Recipient under this Agreement.
            <br/><br/>
            3. Exclusions from Nondisclosure and Nonuse Obligations. Recipient's obligations under Section 2 do not apply to any of Discloser's Confidential Information that: (a) is publicly available at or subsequent to the time the Confidential Information was communicated to Recipient by Discloser through no fault of Recipient; (b) is rightfully in Recipient's possession free of any obligation of confidence at or subsequent to the time the Confidential Information was communicated to Recipient by Discloser; (c) is developed by employees or agents of Recipient independently of and without reference to any of Discloser's Confidential Information; or (d) is communicated by Discloser to an unaffiliated third party free of any obligation of confidence. A disclosure by Recipient of any of Discloser's Confidential Information (i) in response to a valid order by a court or other governmental body; (ii) as otherwise required by law; or (iii) necessary to establish the rights of either party under this Agreement shall not be considered to be a breach of this Agreement by Recipient; provided, however, that Recipient provides prompt prior written notice thereof to Discloser to enable Discloser to seek a protective order or otherwise prevent the disclosure.
            <br/><br/>
            4. Ownership and Return of Confidential Information and Other Materials. All of Discloser's Confidential Information, and any Evaluation Material (defined below) thereof, whether created by Discloser or Recipient, are the property of Discloser and no license or other rights to Discloser's Confidential Information or Derivatives is granted or implied hereby. For purposes of this Agreement, "Evaluation Material" means all reports, studies, analyses, interpretations, compilations, memoranda, notes, and any other written or electronic materials prepared by Recipient or any of its Representatives which contain, reflect or are derived or are based upon, in whole or in part, any Confidential Information furnished by Discloser. "Representatives" means and includes a party's directors, officers, and other employees, as well as their financial advisors, legal counsel, accountants, consultants and other advisors, agents and representatives. All materials (including, without limitation, documents, drawings, papers, storage media, tapes, models, apparatus, sketches, designs and lists) furnished by Discloser to Recipient (whether or not they contain or disclose Discloser's Confidential Information) are the property of Discloser. Within five days after any request by Discloser, Recipient shall, to the extent reasonably possible, destroy (including delete) or deliver to Discloser, at Discloser's option, (a) all Discloser-furnished materials and (b) all materials in Recipient's possession or control (even if not Discloser-furnished) that contain or disclose any of Discloser's Confidential Information or Evaluation Materials, except that Discloser may, subject to the confidentiality provisions of this Agreement, retain a copy of this Agreement for its business records and may retain other Confidential Information as necessary to establish its compliance with this Agreement. Recipient will provide Discloser a written certification of Recipient's compliance with Recipient's obligations under this Section.
            <br/><br/>
            5. Independent Development. Recipient may currently or in the future be developing information internally, or receiving information from other parties that may be similar to Discloser's Confidential Information. Accordingly, nothing in this Agreement will be construed as a representation or inference that Recipient will not develop or have developed products or services, that, without violation of this Agreement, might compete with the products or systems contemplated by Discloser's Confidential Information.
            <br/><br/>
            6. Disclosure of Third Party Information. Neither party shall communicate any information to the other in violation of the proprietary rights of any third party.
            <br/><br/>
            7. No Warranty. All Confidential Information is provided by Discloser "AS IS" and without any warranty, express, implied or otherwise, regarding the Confidential Information's completeness, accuracy or performance.
            <br/><br/>
            8. No Export. Recipient will obtain any licenses or approvals the U.S. government or any agency thereof requires prior to exporting, directly or indirectly, any technical data acquired from Discloser pursuant to this Agreement or any product utilizing that data.
            <br/><br/>
            9. Term.This Agreement is effective upon the Effective Date and continues until it is terminated. A party may terminate this Agreement at any time upon 10 days' written notice. This Agreement will govern all communications between the parties that are made from the Effective Date to the date on which either party receives from the other written notice that subsequent communications shall not be so governed; provided, however, that Recipient's obligations under Section 2 will continue in perpetuity with respect to Discloser's Confidential Information that Recipient has previously received until the obligations no longer apply pursuant to Section 3.
            <br/><br/>
            10. No Assignment.Except to an affiliate or in connection with a merger, acquisition or sale of all or substantially all of its assets or other business combination transaction, neither party will assign or transfer any rights under this Agreement without the prior written consent of the other party, which consent shall not be unreasonably withheld. Any attempted assignments in violation of this Section is void.
            <br/><br/>
            11. Injunctive Relief. A breach by Recipient of this Agreement will cause irreparable and continuing damage to Discloser for which money damages are insufficient, and Discloser shall be entitled to seek injunctive relief and/or a decree for specific performance, and other relief as may be proper (including money damages if appropriate).
            <br/><br/>
            12. Notices. Any notice required or permitted by this Agreement shall be in writing and shall be delivered as follows, with notice deemed given as indicated: (a) by personal delivery, when delivered personally; (b) by overnight courier, upon written verification of receipt; (c) by or facsimile transmission, upon acknowledgment of receipt of electronic transmission; or (d) by certified or registered mail, return receipt requested, upon verification of receipt. Notice shall be sent to the addresses set forth above or to such other address as either party may provide in writing.
            <br/><br/>
            13. Governing Law; Forum. The laws of the United States of America and the State of California govern all matters arising out of or relating to this Agreement without giving effect to any conflict of law principles. Each of the parties irrevocably consents to the exclusive personal jurisdiction of the federal and state courts located in Santa Clara County, California, as applicable, for any matter arising out of or relating to this Agreement, except that in actions seeking to enforce any order or any judgment of the federal or state courts located in Santa Clara County, California, such personal jurisdiction will be non-exclusive. Additionally, notwithstanding anything in the foregoing to the contrary, a claim for equitable relief arising out of or related to this Agreement may be brought in any court of competent jurisdiction. If a proceeding is commenced to resolve any dispute that arises between the parties with respect to the matters covered by this Agreement, the prevailing party in that proceeding is entitled to receive its reasonable attorneys' fees, expert witness fees and out-of-pocket costs, in addition to any other relief to which that prevailing party may be entitled.
            <br/><br/>
            14. Severability. If a court of law holds any provision of this Agreement to be illegal, invalid or unenforceable, (a) that provision shall be deemed amended to achieve an economic effect that is as near as possible to that provided by the original provision and (b) the legality, validity and enforceability of the remaining provisions of this Agreement shall not be affected thereby.
            <br/><br/>
            15. Waiver; Modification. If a party waives any term, provision or a party's breach of this Agreement, such waiver shall not be effective unless it is in writing and signed by the party against whom such waiver is asserted. No waiver by a party of a breach of this Agreement by the other party shall constitute a waiver of any other or subsequent breach by such other party. This Agreement may be modified only if authorized representatives of both parties consent in writing.
            <br/><br/>
            16. Entire Agreement. This Agreement constitutes the entire agreement between the parties with respect to the subject matter of this Agreement. It supersedes all agreements, whether prior or contemporaneous, written or oral, concerning such subject matter.
                            </CardBody>
              </Card>
              </div>
            </Card.Header>
            <Card.Body className="p-0">
              <Row className="d-flex justify-content-center">
                <div className="mx-3">
                  <p className="fs--1 mb-5 text-center">
                    IN WITNESS WHEREOF, the parties are signing this Agreement
                    as of the {new Date().getFullYear()}-
                    {new Date().toLocaleString("default", { month: "short" })}-
                    {new Date().getDate()}.
                  </p>
                </div>
                <Form
                  className="col-10"
                  onSubmit={handleSubmit(handleSubmitNDASubmit)}
                >
                  <Row>
                    <Col sm={6}>
                      <FormGroup className="d-flex flex-column align-items-center">
                        <Label className="mb-3" for="company">
                          "Company"
                        </Label>
                        <Input
                          name="company"
                          id="company"
                          size="sm"
                          value="SIKKA SOFTWARE CORPORATION"
                          readOnly
                          type="text"
                          className={classNames("fs--1", {
                            "border-danger": errors["company"]?.message,
                          })}
                        />
                        <SikkaError
                          error={errors["company"]?.message}
                          className="mt-1"
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={6}>
                      <FormGroup className="d-flex flex-column align-items-center">
                        <Label className="mb-3" for="otherParty">
                          "Other Party"
                        </Label>
                        <Input
                          name="otherParty"
                          id="otherParty"
                          size="sm"
                          value={loginUserDetails?.partner_name}
                          readOnly
                          type="text"
                          innerRef={register({
                            required: "This field is required",
                          })}
                          className={classNames("fs--1")}
                        />
                        <SikkaError
                          error={errors["otherParty"]?.message}
                          className="mt-1"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <FormGroup className="">
                        <Label for="otherParty">By:</Label>
                        <Input
                          name="ByDefault"
                          id="ByDefault"
                          size="sm"
                          value="Roger E Telegan"
                          readOnly
                          type="text"
                          className={classNames("fs--1", {
                            "border-danger": errors["ByDefault"]?.message,
                          })}
                        />
                        <SikkaError
                          error={errors["ByDefault"]?.message}
                          className="mt-1"
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={6}>
                      <SikkaInput
                        label="By:"
                        id="by"
                        name="by"
                        size="sm"
                        innerRef={register({
                          required: "This field is required",
                        })}
                        errors={errors}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <FormGroup className="">
                        <Label for="otherParty">Name:</Label>
                        <Input
                          name="name"
                          id="name"
                          size="sm"
                          value="Roger E Telegan"
                          readOnly
                          type="text"
                          className={classNames("fs--1")}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={6}>
                      <SikkaInput
                        label="Name:"
                        id="name"
                        name="name"
                        size="sm"
                        innerRef={register({
                          required: "This field is required",
                        })}
                        errors={errors}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <FormGroup className="">
                        <Label for="otherParty">Title:</Label>
                        <Input
                          name="title"
                          id="title"
                          size="sm"
                          value="Chief Privacy Officer"
                          readOnly
                          type="text"
                          className={classNames("fs--1")}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={6}>
                      <SikkaInput
                        label="Title:"
                        id="title"
                        name="title"
                        size="sm"
                        innerRef={register({
                          required: "This field is required",
                        })}
                        errors={errors}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <FormGroup className="">
                        <Label for="otherParty">Signature:</Label>
                        <Col className="px-0 mt-1" xs={12} md={12}>
                          <Image
                            className="px-sm-4 px-md-6 px-lg-8 px-xl-9 py-4"
                            style={{
                              border: "1px solid grey",
                              width: "100%",
                              height: "120px",
                              objectFit: "contain",
                            }}
                            src={NDASignatureRoger}
                            height="110px"
                            width="360px"
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="">
                        <Label for="otherParty">Signature:</Label>

                        <SignaturePad
                          ref={(ref) => {
                            sigPad = ref;
                          }}
                          onEnd={(x) => setTrimmedDataURL(x.toDataURL())}
                          options={{ backgroundColor: "#f6f8fa" }}
                          height={125}
                          // {...register("signature", {
                          //   required: "Signature is required",
                          //   validate: () => {
                          //     return false;
                          //   },
                          // })}
                        />
                        <SikkaError error={signatureError} className="mt-1" />

                        {/* <button onClick={clear}>Clear</button> */}

                        {/* <Button size="sm" color="primary" onClick={trim} className="mx-2 mb-1">
                        Trim
                      </Button> */}
                        <Col className="d-flex flex-row-reverse px-0">
                          <Button
                            size="sm"
                            variant="outline-primary"
                            onClick={clear}
                            className="mb-1"
                          >
                            Clear
                          </Button>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={6}>
                      <FormGroup className="">
                        <Label for="dateCompany">Date:</Label>
                        <Input
                          name="dateCompany"
                          id="dateCompany"
                          size="sm"
                          value={`${new Date().getFullYear()}-${new Date().toLocaleString("default", { month: "short" })}-${new Date().getDate()}`}
                          readOnly
                          type="text"
                          className={classNames("fs--1")}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm={6}>
                      <SikkaInput
                        label="Date:"
                        id="date"
                        name="date"
                        size="sm"
                        type="text"
                        readOnly
                        defaultValue={`${new Date().getFullYear()}-${new Date().toLocaleString("default", { month: "short" })}-${new Date().getDate()}`}
                        innerRef={register({
                          required: "This field is required",
                        })}
                        errors={errors}
                      />
                    </Col>
                  </Row>
                  <Row className="mt-2">
                    <Col className="flex-row">
                      <FormGroup className="d-flex flex-wrap align-items-center justify-content-center">
                        <Label className="m-0" for="otherParty">
                          Purpose :
                        </Label>
                        <div className="col-8">
                        <Input
                          name="purpose"
                          id="purpose"
                          size="sm"
                          defaultValue="to have discussion to explore a potential business relationship between the parties"
                          type="text"
                          innerRef={register({
                            required: "This field is required",
                          })}
                          className={classNames({
                            "border-danger": errors["purpose"]?.message,
                          })}
                        />
                        <SikkaError error={errors["purpose"]?.message} />
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mt-4 mb-4 d-flex justify-content-center">
                    <LoadingButton
                      size="sm"
                      loading={loading}
                      disabled={loading}
                      color="success"
                      block={true}
                      className="mr-3"
                      style={{ width: "200px" }}
                    >
                      Save
                    </LoadingButton>
                    {/* <Button variant="success" type="submit" size="sm" className="mr-3 w-25" disabled={loading}>
                      Save
                    </Button> */}
                    <Button
                      style={{ width: "200px" }}
                      size="sm"
                      variant="danger"
                      onClick={() => {
                        AuthService.logout();
                        history.push("/v4/portal/authentication/login");
                      }}
                      disabled={loading}
                    >
                      Cancel
                    </Button>
                  </Row>
                  <Row className="mb-4">
                    <FormGroup check>
                      <Col className="justify-content-center">
                        <Input
                          type="checkbox"
                          id="NDASignedBoolean"
                          name="NDASignedBoolean"
                          size="sm"
                          onClick={() => setUploadNDABoolean(true)}
                          errors={errors}
                          disabled={loading}
                        />
                        <Label check style={{ marginTop: "9px" }}>
                          Non-Disclosure Agreement already signed
                        </Label>
                        {/* <Label>Non-Disclosure Agreement already signed</Label> */}
                      </Col>
                    </FormGroup>
                  </Row>
                </Form>
              </Row>
            </Card.Body>
          </Card>
          <footer>
            <Row
              noGutters
              className="justify-content-between text-center fs--1 mt-4 mb-3 px-3"
            >
              <Col sm="auto">
                <p className="fs--1 mb-0 text-600">
                  &copy; {new Date().getFullYear()} Copyright Sikka Software
                  Corporation.All Rights Reserved | Leading AI infrastructure as a Service (AIaaS) for Retail Healthcare
                </p>
              </Col>
              <Col sm="auto">
                <p className="fs--1 mb-0 text-600">Sikka API Portal v4.0.0</p>
              </Col>
            </Row>
          </footer>
        </div>
      )}
    </>
  );
};

export default SignNDA;
